<template>
  <InputNumber v-bind="$attrs">
    <template #incrementicon>
      <PlusIcon />
    </template>
    <template #decrementicon>
      <MinusIcon />
    </template>
  </InputNumber>
</template>
<script lang="ts" setup>
import InputNumber from 'primevue/inputnumber'
import PlusIcon from '../Icons/PlusIcon'
import MinusIcon from '../Icons/MinusIcon'
</script>

<style>
:deep(.p-inputtext) {
  text-align: center;
}

.quantity-input {
  margin-right: 4px;
}

.tw-bootstrap-override {
  width: 70px;
  margin-right: 4px;
}

.tw-bootstrap-override .p-inputnumber-input {
  font-size: 14px;
  line-height: 18px;
  width: 70px;
}

.tw-bootstrap-override button.p-inputnumber-button {
  border-left: 1px var(--border-default-color) solid !important;
}

.tw-bootstrap-override .tw-input-stepper-button {
  font-size: 0.75rem;
  line-height: 1rem;
  .p-inputnumber-button {
    color: var(--icon-default);
    background-color: var(--color-surface-neutral);
  }
  .p-inputnumber-button:hover:not(:disabled) {
    background-color: var(--color-surface-neutral-hovered);
    color: var(--icon-default);
  }
  .p-inputnumber-button:active:not(:disabled) {
    background-color: var(--color-surface-neutral-pressed);
  }
  .p-inputnumber-button.p-disabled,
  .p-inputnumber-button.p-disabled:disabled {
    color: var(--icon-default);
  }
  .p-inputnumber-increment-button {
    border-style: solid;
    border-bottom-width: 1px;
    border-color: var(--border-default-color);
  }
  .p-disabled {
    cursor: not-allowed !important;
    background-color: var(--action-primary-disabled);
  }
}
</style>
